import { defineComponent as _defineComponent } from 'vue'
import { CompanyReport, TtCompanyReport } from '@/CodegenTypes';
import { formatDollar } from '@/helpers/formatDollar';
import { negateNumber } from '@/helpers/negateNumber';
import { useTranslation } from '@/store/translation';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyPlTable',
  props: {
    companyReport: null,
    rightPad: null,
    colspan: null
  },
  setup(__props: any) {

const props = __props as { companyReport?: CompanyReport | TtCompanyReport, rightPad?: number, colspan?: string };

const { $t } = useTranslation();




const companyFinalNet = computed(() => {
    const report = props.companyReport as unknown as {
        companyTicketsFinal?: { summary?: { net?: number } };
        companyTicketsFinalLessExpenses?: { summary?: { net?: number } };
    } | null | undefined;

    return (
        report?.companyTicketsFinalLessExpenses?.summary?.net ??
        report?.companyTicketsFinal?.summary?.net ??
        0
    );
});

const gaps = computed(() => {
    if (!props.rightPad) {
        return [];
    }
    const gaps = [];
    for (let i = 0; i < props.rightPad; i++) {
        gaps.push(i);
    }
    return gaps;
});

const showPercent = computed(() => process.env.VUE_APP_SHOW_PL_PERCENT === "true")

const winLossPercent = computed(() => {
    if (!props.companyReport) {
        return '-';
    }

    const net = companyFinalNet.value;
    const amountLessRebate =
        props.companyReport.companyTickets.summary.amountLessRebate;

    if (net == null || amountLessRebate == null) {
        return null;
    }
    const ratio = net / amountLessRebate;
    return isFinite(ratio) ? ((net / amountLessRebate) * 100).toFixed(2) : 0;

})


return { __sfc: true,$t, props, companyFinalNet, gaps, showPercent, winLossPercent, formatDollar, negateNumber }
}

})